export default __webpack_public_path__ + "static/ubc_coat_of_arms-b1e6e1c28a2fc07e21a36e5f275be6b2.png";